













import Vue from 'vue';

export default Vue.extend({
    name: 'ChooseSubscriptionButton',
    props: {
        filled: {
            type: Boolean,
            default: false,
        },
    },
});
